<template>
    <div id="app">
        <router-view/>

    </div>
</template>

<script>

    import '@/assets/css/datatable.css'
    import '@/assets/css/modal.css'
    import '@/assets/css/table-resize.css'

    import {mapActions} from 'vuex';

    export default {
        name: 'app',
        methods: {
            setScrollbarWith() {
                // Create the measurement node
                var scrollDiv = document.createElement("div");
                scrollDiv.className = "scrollbar-measure";
                document.body.appendChild(scrollDiv);

                // Get the scrollbar width
                var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

                // Delete the DIV
                document.body.removeChild(scrollDiv);
                this.setScrollbarWidth(scrollbarWidth);
            },
            ...mapActions([
                "setScrollbarWidth"
            ])
        },
        mounted() {
            this.setScrollbarWith();
        },
        watch: {
            $route: function (to, from) {
                // TODO : Page visit log for resources and dashboard
            }
        }
    }
</script>

<style>
    body {
        margin: 0;
        background-color: rgb(27, 33, 41);
    }

    #app {
        height: 100vh;
        background-color: rgb(27, 33, 41);
    }

    .grow {
        transition: all .2s ease-in-out;
    }

    .grow:hover {
        transform: scale(1.1);
    }

    input:focus,
    select:focus,
    textarea:focus,
    button:focus {
        outline: none;
    }

    .scrollbar-measure {
        width: 100px;
        height: 100px;
        overflow: scroll;
        position: absolute;
        top: -9999px;
    }

    .enlarge-button {
        width: 64px;
        height: 64px;
        position: absolute;
        top: 0px;
        right: 0px;
        z-index: 6;
    }

    .enlarge-button-icon {
        width: 64px;
    }

    /* A class to line break long texts properly */
    .dont-break-out {
        overflow-wrap: break-word;
        word-wrap: break-word;

        -ms-word-break: break-all;
        word-break: break-all;

        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue